import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Warning } from '@mui/icons-material';

interface SubscriptionRequiredModalProps {
  show: boolean;
  onHide: () => void;
  message?: string;
}

const SubscriptionRequiredModal: React.FC<SubscriptionRequiredModalProps> = ({
  show,
  onHide,
  message = 'An active subscription is required to access this feature'
}) => {
  const navigate = useNavigate();

  const handleGoToBilling = () => {
    onHide();
    navigate('/billing');
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title className="d-flex align-items-center">
          <Warning className="text-warning me-2" />
          Subscription Required
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleGoToBilling}>
          Go to Billing
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubscriptionRequiredModal;